import imageDe from '../images/de/sensotrend_signin_signup.png';
import imageEn from '../images/en/sensotrend_signin_signup.png';
import imageEs from '../images/es/sensotrend_signin_signup.png';
import imageFi from '../images/fi/sensotrend_signin_signup.png';
import imageFr from '../images/fr/sensotrend_signin_signup.png';
import imageIt from '../images/it/sensotrend_signin_signup.png';
import imageNo from '../images/no/sensotrend_signin_signup.png';
import imageSv from '../images/sv/sensotrend_signin_signup.png';

export const signupImage = {
  de() {
    return imageDe;
  },
  en() {
    return imageEn;
  },
  es() {
    return imageEs;
  },
  fi() {
    return imageFi;
  },
  fr() {
    return imageFr;
  },
  it() {
    return imageIt;
  },
  no() {
    return imageNo;
  },
  sv() {
    return imageSv;
  },
};
